// extracted by mini-css-extract-plugin
export default {"root":"DeactivatedUser_root__+vXgN","description":"DeactivatedUser_description__JnO6h"};